import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './common/LanguageSwitcher';
import './SchoolPage.css';

const HighSchoolPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('landing');
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    navigate('/');
    setTimeout(() => {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  // High School streams (Algerian secondary system) — names from i18n
  const streamKeys = [
    { id: 'sciences', nameKey: 'resources.streams.sciences', descKey: 'resources.streams.sciencesDesc', icon: 'science', color: '#1a73e8' },
    { id: 'math', nameKey: 'resources.streams.math', descKey: 'resources.streams.mathDesc', icon: 'calculate', color: '#34a853' },
    { id: 'literature', nameKey: 'resources.streams.literature', descKey: 'resources.streams.literatureDesc', icon: 'menu_book', color: '#ea4335' },
    { id: 'technical-math', nameKey: 'resources.streams.technicalMath', descKey: 'resources.streams.technicalMathDesc', icon: 'engineering', color: '#fbbc04' },
    { id: 'management-economics', nameKey: 'resources.streams.managementEconomics', descKey: 'resources.streams.managementEconomicsDesc', icon: 'account_balance', color: '#9c27b0' }
  ];

  const handleStreamClick = (streamId) => {
    navigate(`/resources/high/${streamId}`);
  };

  return (
    <div className="school-page">
      {/* Navigation Bar */}
      <nav className={`landing-navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="navbar-container">
          <div className="logo" onClick={() => navigate('/')}>
            <span className="material-icons">school</span>
            <span>Nativelike</span>
          </div>
          <div className={`nav-menu ${isMobileMenuOpen ? 'open' : ''}`}>
            <a href="#features" onClick={(e) => { e.preventDefault(); scrollToSection('features'); setIsMobileMenuOpen(false); }}>{t('nav.features')}</a>
            <a href="#how-it-works" onClick={(e) => { e.preventDefault(); scrollToSection('how-it-works'); setIsMobileMenuOpen(false); }}>{t('nav.howItWorks')}</a>
            <a href="#pricing" onClick={(e) => { e.preventDefault(); scrollToSection('pricing'); setIsMobileMenuOpen(false); }}>{t('nav.pricing')}</a>
            <a href="#testimonials" onClick={(e) => { e.preventDefault(); scrollToSection('testimonials'); setIsMobileMenuOpen(false); }}>{t('nav.reviews')}</a>
            <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); setIsMobileMenuOpen(false); }} className="active">{t('nav.resources')}</a>
          </div>
          <div className="nav-actions">
            <LanguageSwitcher className="landing-language-switcher" />
            <button className="btn-login" onClick={() => scrollToSection('login')}>{t('nav.login')}</button>
            <button className="btn-primary" onClick={() => navigate('/signup')}>{t('nav.startLearning')}</button>
            <button className="mobile-menu-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu">
              <span className="material-icons">{isMobileMenuOpen ? 'close' : 'menu'}</span>
            </button>
          </div>
        </div>
      </nav>

      <div className="school-container" style={{ paddingTop: '80px' }}>
        {/* Breadcrumb */}
        <div className="breadcrumb">
          <a href="/resources" onClick={(e) => { e.preventDefault(); navigate('/resources'); }}>{t('nav.resources')}</a>
          <span className="material-icons">chevron_right</span>
          <span>{t('resources.highSchool')}</span>
        </div>

        {/* Header */}
        <div className="school-header">
          <h1 className="school-title">
            <span className="material-icons">menu_book</span>
            {t('resources.highSchoolSecondary')}
          </h1>
          <p className="school-subtitle">
            {t('resources.selectStreamHigh')}
          </p>
        </div>

        {/* Streams Grid */}
        <div className="streams-grid">
          {streamKeys.map((stream) => (
            <div
              key={stream.id}
              className="stream-card"
              onClick={() => handleStreamClick(stream.id)}
            >
              <div className="stream-icon" style={{ backgroundColor: `${stream.color}15`, color: stream.color }}>
                <span className="material-icons">{stream.icon}</span>
              </div>
              <h3>{t(stream.nameKey)}</h3>
              <p>{t(stream.descKey)}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default HighSchoolPage;
